var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"question-label",attrs:{"for":_vm.elementId}},[_vm._v(_vm._s(_vm.question))]),_c('input',{ref:_vm.elementId,staticClass:"form-control",attrs:{"type":"text","id":_vm.elementId},domProps:{"value":_vm.value}})])}
var staticRenderFns = []

export { render, staticRenderFns }